module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("加入會員")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("帳號")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "username",
    attrs: {
      "name": "input-1-5",
      "label": "帳號",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("密碼")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "password",
    staticClass: "input-group",
    attrs: {
      "name": "input-2-5",
      "label": "密碼",
      "type": "password",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("密碼確認")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group",
    attrs: {
      "name": "input-3-5",
      "label": "密碼確認",
      "type": "password",
      "value": "",
      "rules": [function () {
        return _vm.user.password !== _vm.password_confirm ? '與密碼不一致' : true
      }],
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.password_confirm),
      callback: function($$v) {
        _vm.password_confirm = $$v
      },
      expression: "password_confirm"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("姓名")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "realname",
    attrs: {
      "name": "input-4-5",
      "label": "姓名",
      "value": "",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.user.realname),
      callback: function($$v) {
        _vm.$set(_vm.user, "realname", $$v)
      },
      expression: "user.realname"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("聯絡電話")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "phone",
    staticClass: "input-group",
    attrs: {
      "name": "input-5-5",
      "label": "聯絡電話",
      "value": "",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', {
    staticClass: "mt-4",
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.validation()
      }
    }
  }, [_vm._v("註冊")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f60f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 632
// module chunks = 1